// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/School/Detail/index.less
// module id = 913
// module chunks = 0